module.exports = __webpack_public_path__ + "img/Artlles-profile-about.9412bd78.jpg";